import { z } from "zod";
import { taskBaseResource } from "../tasks/task-resource";
import { zStringId } from "../../utils";
import { zUserSnippet } from "../users";

export const zServiceProjectTask = z.object({
  ...taskBaseResource,
  serviceProjectDoc: z.object({
    _id: zStringId(),
    serviceId: zStringId(),
    serviceDetails: z.object({ title: z.string() }),
    clientDoc: zUserSnippet,
  }),
});

export type ServiceProjectTask = z.infer<typeof zServiceProjectTask>;
